import { Controller } from "@hotwired/stimulus";
import * as echarts from "echarts";
let chart: any;
const colors: string[] = [
  "#0284c7", // sky-600
  "#16a34a", // green-600
  "#ea580c", // orange-600
  "#0d9488", // teal-600
  "#f43f5e", // rose-500
  "#eab308", // yellow-500
  "#059669", // emerald-600
  "#84cc16", // lime-500
  "#ef4444", // red-500
  "#0891b2", // cyan-600
  "#db2777", // pink-600
  "#4f46e5", // indigo-600
  "#b45309", // amber-700
  "#c026d3", // fushia-600
  "#2563eb", // blue-600
  "#9333ea", // purple-600
  "#7c3aed", // violet-600
];

// Connects to data-controller="echarts"
export default class extends Controller {
  static targets = ["container"];

  declare containerTarget: HTMLElement;
  declare hasContainerTarget: boolean;

  connect() {
    if (this.hasContainerTarget) {
      chart = echarts.init(this.containerTarget);
      if (this.containerTarget.dataset.options) {
        let option = JSON.parse(this.containerTarget.dataset.options);
        option.color = colors;
        chart.setOption(option);
      }
    }
  }
}
